import { Column } from '../Containers';

import { ZeroDataIcon } from '../Icons';

export function NoDataMessage() {
  return (
    <Column gap="2" alignItems="center" className="p-2">
      <ZeroDataIcon size={36} color="primary" />

      <p className=" font-medium">No data found</p>
    </Column>
  );
}
